import { document } from '../../../../helpers/BrowserHelpers';

function blurElement(database) {
  if (!database.element) return database;
  database.element.blur();
  return database;
}

function focusElement(database) {
  if (!database.element) return database;
  var selection = document.getSelection();

  if (selection.rangeCount > 0) {
    selection.removeAllRanges();
  }

  database.element.focus();
  return database;
}

function isElementInDatabase(database, element) {
  return database.element ? element === database.element || database.element.contains(element) : false;
}

function isFocusInDatabase(database) {
  if (!database.isElementInDatabase(document.activeElement)) return false;
  var selection = document.getSelection();
  if (selection.rangeCount <= 0) return true;
  return database.isElementInDatabase(selection.anchorNode) && database.isElementInDatabase(selection.focusNode);
}

export default {
  commands: {
    blurElement: blurElement,
    focusElement: focusElement
  },
  queries: {
    isElementInDatabase: isElementInDatabase,
    isFocusInDatabase: isFocusInDatabase
  }
};